







import { Coord } from "../models/Coord";

export default {
    name: "ContactCoordsEdit",
    props: {
        coords: {
            type: Object as () => Coord,
        },
    },
    data() {
        return {
            map: null,
            marker: null,
        };
    },
    mounted() {
        this.initMap();
    },
    methods: {
        initMap: async function () {
            let self = this;
            // Request needed libraries.
            const { Map, InfoWindow } = (await google.maps.importLibrary(
                "maps"
            )) as google.maps.MapsLibrary;
            const { AdvancedMarkerElement } = (await google.maps.importLibrary(
                "marker"
            )) as google.maps.MarkerLibrary;

            const map = new Map(document.getElementById("map") as HTMLElement, {
                center: { lat: 37.39094933041195, lng: -122.02503913145092 },
                zoom: 18,
                mapId: "4504f8b37365c3d0",
            });

            const infoWindow = new InfoWindow();

            const draggableMarker = new AdvancedMarkerElement({
                map,
                position: { lat: 37.39094933041195, lng: -122.02503913145092 },
                gmpDraggable: true,
                title: "Copropriété",
            });
            draggableMarker.addListener("dragend", (event) => {
                const position = draggableMarker.position as google.maps.LatLng;
                infoWindow.close();
                infoWindow.setContent("Position mise à jour");
                infoWindow.open(draggableMarker.map, draggableMarker);
                self.$emit("update-coords", {
                    lat: position.lat,
                    lng: position.lng,
                });
            });
            this.map = map;
            this.marker = draggableMarker;
            if (this.coords && this.coords.lat !== 0) {
                this.updateCoords();
            }
        },
        updateCoords() {
            this.marker.position = {
                lat: this.coords.lat,
                lng: this.coords.lng,
            };
            this.map.setCenter({
                lat: this.coords.lat,
                lng: this.coords.lng,
            });
        },
    },
    watch: {
        coords: {
            handler: function (newCoords: Coord) {
                if (
                    newCoords &&
                    newCoords.lat !== 0 &&
                    this.map &&
                    this.marker
                ) {
                    this.updateCoords();
                }
            },
            immediate: true,
        },
    },
};
